<template>
  <Layout>
    <template #header>
      <div class="text-center">转向失效备份功能</div>
    </template>
    <template #default>
      <div class="row q-col-gutter-x-md full-height">
        <div class="col-4 col-xs-12 col-sm-4 column justify-around">
          <q-card dark bordered class="full-height column">
            <q-card-section>
              <div class="text-h6">请选择车辆配置</div>
            </q-card-section>
            <q-separator inset />
            <q-card-section class="overflow-hidden">
              <div>
                <q-option-group size="100px" v-model="accepted" :options="options" color="green" type="toggle"
                  class="toggle-style" />
                <q-toggle :label="forwardTurningFailure" v-model="forwardTurningFailure" checked-icon="check"
                  size="100px" color="green" unchecked-icon="clear" false-value="前转正常" true-value="前转失效"
                  class="toggle-style" />
              </div>
            </q-card-section>
          </q-card>
        </div>
        <!-- 右半部分 -->
        <div class="col-8 col-xs-12 col-sm-8 right-column">
          <q-card dark bordered class="column full-height">
            <q-card-section class="row items-center">
              <div class="text-h6 text-center">车辆实际转向</div>
            </q-card-section>
            <q-separator inset />
            <div class="chart-container">
              <div class="chart-left">
                <AngleWheel :value="forwardTurningFailure === '前转失效' ? positiveValue : 0" :max="50" :min="0"
                  class="chart" />
              </div>
              <q-img :src="'/方向盘失灵.png'" :style="{
                transform: forwardTurningFailure === '前转失效' ? positiveValue > 0 ? `rotate(${-positiveValue}deg)` : `rotate(${-negativeValue}deg)` : `rotate(0deg)`,
                maxWidth: '60%',
                height: 'auto',
                transition: 'transform 0.5s ease',
                margin: 'auto'
              }" />
              <div class="chart-right">
                <AngleWheel :value="forwardTurningFailure === '前转失效' ? Math.abs(negativeValue) : 0" :max="50" :min="0"
                  class="chart" />
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { NOTIFY } from "@/services/domainControl/sbtv";
import { SERVICE } from "@/services/domainControl/define";
import { useDomainControlStore } from "@/stores/domainControl";
import Layout from "./components/Layout.vue";
import AngleWheel from "@/components/AngleWheel.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { useQuasar } from "quasar";
import { onBeforeRouteLeave } from "vue-router";
const $q = useQuasar();
const domainControlStore = useDomainControlStore();
const accepted = ref<string[]>([]);
const forwardTurningFailure = ref("前转正常");
// 负值
const negativeValue = ref(0);
// 正值
const positiveValue = ref(0);

const options = ref([
  {
    label: '配置后转',
    value: '配置后转'
  }
]);
// 获取数据
const handleNotify = (data: DomianControl.SBTVNotifyData) => {
  if (forwardTurningFailure.value === "前转失效") {
    if (data.UIRx_ACUYawRate < 0) {
      // 取绝对值
      negativeValue.value = data.UIRx_ACUYawRate;
      positiveValue.value = 0;
    } else {
      positiveValue.value = data.UIRx_ACUYawRate;
      negativeValue.value = 0;
    }
  }
};

const parseOutputValue = (value: DomianControl.OutputValue) => {
  console.log("[BOWEN_LOG] 🚀 ~~ parseOutputValue ~~ value:", value);
  const { UITx_SbTvRwsEna } = value;
  if(UITx_SbTvRwsEna === 1){
    accepted.value = ["配置后转"];
  }
};
useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

const handleSliderChange = (type: string, value: number) => {
  domainControlStore.writeOutputValue({
    [type]: value,
  });
};

watch(
  () => forwardTurningFailure.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      const value = newValue === "前转失效" ? 3 : 0;
      handleSliderChange("UITx_SbTv_Ena", value);
    }
  }
);

watch(
  () => accepted.value,
  (newValue, oldValue) => {
    console.log(accepted.value);
    if (newValue !== oldValue) {
      // 取出对象中的值
      const value = newValue[0] === "配置后转" ? 1 : 0;
      handleSliderChange("UITx_SbTvRwsEna", value);
    }
  }
);
onBeforeRouteLeave((to, from) => {
  if (forwardTurningFailure.value !== "前转正常") {
    $q.notify({
      color: "red-6",
      position: "top",
      message: `请关闭SBTV功能`,
      icon: "report_problem",

    })
    return false;
  }
})

// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockDURNofifyData() as any);
//   }, 5000);
// });
</script>

<style scoped>
.toggle-style {
  font-size: 24px;
  margin-bottom: 30px;
  margin-top: 8vw;
}

.chart-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 8vw;
}

.chart-left,
.chart-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart {
  width: 80%;
  height: 400px;
}

.img-active {
  max-width: 60%;
  height: auto;
  transform: rotate(10deg);
  transition: transform 0.5s ease;
  margin: auto;
}

.img-inactive {
  max-width: 60%;
  height: auto;
  -webkit-filter: grayscale(100%);
  transition: transform 0.5s ease;
  margin: auto;
}

@media (max-width: 768px) {
  .chart-container {
    flex-direction: column;
  }

  .chart-left,
  .chart-right {
    margin-top: 20px;
  }

  .toggle-style {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .chart {
    width: 100%;
    height: 300px;
  }

  .img-active,
  .img-inactive {
    max-width: 100%;
  }
}
</style>